import styled from "styled-components";
import SearchButton from "./SearchButton";

export const Card = styled.div`
  border-radius: 0px;
  background: white;
  box-shadow: 0px 8px 32px 4px rgba(0, 0, 0, 0.5);
  width: 100%;
  height: calc(100% - 50px);
  padding: 5px 20px;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  span {
    font-weight: bold;
  }
`;

export const CardContainer = styled.div`
  position: absolute;
  bottom: 0px;
  z-index: 1;
  padding: 0px;
  width: 100%;
  height: 50vh;
  @media screen and (min-width: 768px) {
    position: relative;
    width: 35vw;
    height: 100vh;
    transition: filter 1s ease-in-out;
    filter: ${({ loading }) => (loading ? "blur(5px);" : "blur(0px)")};
  }
  ${SearchButton} {
    position: absolute;
    bottom: 10px;
    right: 10px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Card.js